import React from 'react';
import CustomComboBox from '@/components/CustomComboBox';

type P = {
  handleSelected: (value: string) => void;
  list: {
    value: string;
    title: string;
  }[];
};

const SortPopover = ({ handleSelected, list }: P) => {
  return (
    <CustomComboBox
      list={list}
      handleSelected={handleSelected}
      style={{ marginLeft: '8px', width: '144px' }}
      headerStyle={{ height: '44px' }}
    />
  );
};

export default SortPopover;
